import React, { useState, useContext, useEffect, Fragment } from 'react';
import { string } from 'prop-types';
import axios from 'axios';
import classNames from 'classnames/bind';
import Slider from 'react-slick';
import stylesSlider from 'slick-carousel/slick/slick.css';

import { StaticTextContext } from 'context/StaticTextContext';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { backendUrl, basicAuth } from 'utils/constantsHelper';
import { langCodeTA } from 'utils/currentLanguage';
import { getSettings } from 'utils/sliderSharedSettings';

import Container from 'components/Container';
import LatestBulletinsItem from 'components/LatestBulletinsItem';
import Loader from 'components/Loader';

import styles from './LatestBulletins.module.scss';
const cx = classNames.bind(styles, stylesSlider);

const LatestBulletins = ({ className }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const { labels } = useContext(StaticTextContext);
  const settings = getSettings(cx('icon-arrow'));

  useEffect(() => {
    axios({
      method: 'get',
      url:
        backendUrl +
        langCodeTA +
        '/api/v1/lastest_technical_bulletin?_format=json',
      headers: {
        ...basicAuth,
      },
    })
      .then(({ status, data }) => {
        setData(status === 200 ? data : []);
      })
      .catch(() => {
        setData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Fragment>
      {!!data && !!data.length ? (
        <section className={cx('root', className)}>
          <h2 className={cx('section-title')}>{labels.latestBulletinsTitle}</h2>
          <div className={cx('section')}>
            <Container>
              <Slider {...settings} className={cx('listing')}>
                {data.map((item, index) => (
                  <LatestBulletinsItem data={item} key={index} />
                ))}
              </Slider>
            </Container>
          </div>
        </section>
      ) : null}
    </Fragment>
  );
};

LatestBulletins.propTypes = {
  className: string,
};

LatestBulletins.defaultProps = {
  className: null,
};

export default withErrorBoundary(LatestBulletins);



// WEBPACK FOOTER //
// ./src/components/LatestBulletins/LatestBulletins.js